/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceLeaderboardDemoEntry
 */
export interface SurfaceLeaderboardDemoEntry {
    /**
     * 
     * @type {number}
     * @memberof SurfaceLeaderboardDemoEntry
     */
    rank?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceLeaderboardDemoEntry
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceLeaderboardDemoEntry
     */
    score?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceLeaderboardDemoEntry
     */
    avatarUrl?: string;
    /**
     * Rank change from previous (positive = improved)
     * @type {number}
     * @memberof SurfaceLeaderboardDemoEntry
     */
    change?: number;
}

/**
 * Check if a given object implements the SurfaceLeaderboardDemoEntry interface.
 */
export function instanceOfSurfaceLeaderboardDemoEntry(value: object): value is SurfaceLeaderboardDemoEntry {
    return true;
}

export function SurfaceLeaderboardDemoEntryFromJSON(json: any): SurfaceLeaderboardDemoEntry {
    return SurfaceLeaderboardDemoEntryFromJSONTyped(json, false);
}

export function SurfaceLeaderboardDemoEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceLeaderboardDemoEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'rank': json['rank'] == null ? undefined : json['rank'],
        'name': json['name'] == null ? undefined : json['name'],
        'score': json['score'] == null ? undefined : json['score'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'change': json['change'] == null ? undefined : json['change'],
    };
}

export function SurfaceLeaderboardDemoEntryToJSON(json: any): SurfaceLeaderboardDemoEntry {
    return SurfaceLeaderboardDemoEntryToJSONTyped(json, false);
}

export function SurfaceLeaderboardDemoEntryToJSONTyped(value?: SurfaceLeaderboardDemoEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rank': value['rank'],
        'name': value['name'],
        'score': value['score'],
        'avatarUrl': value['avatarUrl'],
        'change': value['change'],
    };
}

